import * as bootstrap from 'bootstrap';
import BootstrapUtil from './utility/bootstrap/bootstrap.util';
import ViewportWidthUtil from './utility/viewport/viewport-width.util';
import PollFormModule from './module/poll-form.module';
import PollResultModule from './module/poll-result.module';
import SearchAutocompleteModule from './module/search-autocomplete.module';
import { EventsManagerBookingFormModule } from './module/events-manager-booking-form.module';
import Select2Util from './utility/select2/select2.util';
import DataTableModule from './module/data-table.module';
import LatestUpdatesModule from './module/latest-updates.module';
import DownloadKeyFormModule from './module/download-key-form.module';

window.bootstrap = bootstrap;

BootstrapUtil.initBootstrapPlugins();
Select2Util.initSelect2();

new ViewportWidthUtil();

window.addEventListener('DOMContentLoaded', () => {

  const modules = {
    '.poll-form': PollFormModule,
    '[data-poll-result]': PollResultModule,
    '.em-booking-form': EventsManagerBookingFormModule,
    '.data-table': DataTableModule,
    '.latest-updates': LatestUpdatesModule,
    '.download-key': DownloadKeyFormModule,
  };

  for (const [selector, module] of Object.entries(modules)) {
    document.querySelectorAll(selector)?.forEach(el => new module(el));
  }

  SearchAutocompleteModule.initAll('.wp-block-search', {
    perPage: 6,
    minChars: 2,
    subtypes: [],
    seeAllText: 'Alle Ergebnisse anzeigen',
  });

});